export default "/build/static/fonts/Whitney-Bold_Web.woff2";